export namespace TokenNs {

  export enum GrantType {
    Password = 'password',
    RefreshToken = 'refresh_token'
  }

  export interface TokenData {
    accessToken: string,
    refreshToken: string,
    tokenType: string,
  }

  export interface CreateTokenRequest {
    username: string,
    password: string,
    grant_type: GrantType
  }

  export interface CreateTokenResponse {
    access_token: string
    token_type: string
    refresh_token: string
    expires_in: number
    scope: string
    auth_type: string,
    user_agent: string,
    jti: string
  }

  export interface RefreshTokenRequest {
    grant_type: GrantType,
    refresh_token: string
  }

}
